export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
console.log("🚀 ~ API_BASE_URL:", API_BASE_URL);
export const AUTH_SERVICE = "auth-service/api/";
export const USER_SERVICE = "user-service/api/";
export const PROJECT_SERVICE = "project-service/api/";
